module.exports = __webpack_public_path__ + "media/guac-mobile.a14f20d7.mp4";